export const djdroneparkingList = [
  {
    parking: '1구역',
    id: 1,
    lots: [
      {
        name: '1번 주차장',
        distance: '48m',
        latitude: 36.89142490244978,
        longitude: 126.82322516953464,
        address: '운정리 213-1', // 찍어서 나오게 수정
        accessurl: 'https://tmap.life/5c1522e3',
        complexity: '여유',
      },
      {
        name: '2번 주차장',
        distance: '48m',
        latitude: 36.891658685883876,
        longitude: 126.82288807336735,
        address: '운정리 214-5',
        accessurl: 'https://tmap.life/5c1522e3',
        complexity: '여유',
      },
      {
        name: '3번 주차장',
        distance: '75m',
        latitude: 36.892009090773314,
        longitude: 126.82220292795054,
        address: '운정리 214-4',
        accessurl: 'https://tmap.life/5c1522e3',
        complexity: '여유',
      },
      {
        name: '4번 주차장',
        distance: '192m',
        latitude: 36.8922605102747,
        longitude: 126.82161056065385,
        address: '운정리 957',
        accessurl: 'https://tmap.life/5c1522e3',
        complexity: '여유',
      },
      {
        name: '5번 주차장',
        distance: '181m',
        latitude: 36.89161826987276,
        longitude: 126.8214718230709,
        address: '운정리 958-1',
        accessurl: 'https://tmap.life/5c1522e3',
        complexity: '여유',
      },
      {
        name: '6번 주차장',
        distance: '198m',
        latitude: 36.89161146109454,
        longitude: 126.82143818323901,
        address: '운정리 959-1',
        accessurl: 'https://tmap.life/5c1522e3',
        complexity: '여유',
      },
      {
        name: '7번 주차장',
        distance: '268m',
        latitude: 36.891045019361385,
        longitude: 126.82077200302773,
        address: '운정리 262-22',
        accessurl: 'https://tmap.life/5c1522e3',
        complexity: '여유',
      },
      {
        name: '8번 주차장',
        distance: '216m',
        latitude: 36.89036178591355,
        longitude: 126.82183654175569,
        address: '운정리 209',
        accessurl: 'https://tmap.life/5c1522e3',
        complexity: '여유',
      },
    ],
  },
  {
    parking: '2구역',
    id: 2,
    lots: [
      {
        name: '9번 주차장',
        distance: '267m',
        latitude: 36.890252568679095,
        longitude: 126.82413235329629,
        address: '운정리 963-5',
        accessurl: 'https://tmap.life/5c1522e3',
        complexity: '여유',
      },
      {
        name: '10번 주차장',
        distance: '287m',
        latitude: 36.88959901326339,
        longitude: 126.82395716474927,
        address: '운정리 964-2',
        accessurl: 'https://tmap.life/5c1522e3',
        complexity: '여유',
      },
      {
        name: '11번 주차장',
        distance: '429m',
        latitude: 36.88908387904536,
        longitude: 126.82446036170799,
        address: '운정리 187-3',
        accessurl: 'https://tmap.life/5c1522e3',
        complexity: '여유',
      },
      {
        name: '12번 주차장',
        distance: '397m',
        latitude: 36.88888027644892,
        longitude: 126.82540876268234,
        address: '운정리 187-14',
        accessurl: 'https://tmap.life/5c1522e3',
        complexity: '여유',
      },
    ],
  },
  {
    parking: '3구역',
    id: 3,
    lots: [
      {
        name: '13번 주차장',
        distance: '581m',
        latitude: 36.88844144663603,
        longitude: 126.82418979365872,
        address: '운정리 890',
        accessurl: 'https://tmap.life/5c1522e3',
        complexity: '여유',
      },
      {
        name: '14번 주차장',
        distance: '622m',
        latitude: 36.88767719484559,
        longitude: 126.82533017180222,
        address: '운정리 168',
        accessurl: 'https://tmap.life/5c1522e3',
        complexity: '여유',
      },
      {
        name: '15번 주차장',
        distance: '595m',
        latitude: 36.88765254817907,
        longitude: 126.82389432601708,
        address: '운정리 891-1',
        accessurl: 'https://tmap.life/5c1522e3',
        complexity: '여유',
      },
      {
        name: '16번 주차장',
        distance: '649m',
        latitude: 36.887134243792524,
        longitude: 126.82377772841656,
        address: '운정리 894',
        accessurl: 'https://tmap.life/5c1522e3',
        complexity: '여유',
      },
      {
        name: '17번 주차장',
        distance: '682m',
        latitude: 36.88645100342086,
        longitude: 126.82485620824222,
        address: '운정리 168-4',
        accessurl: 'https://tmap.life/5c1522e3',
        complexity: '여유',
      },
    ],
  },
  {
    parking: '4구역',
    id: 4,
    lots: [
      {
        name: '21번 주차장',
        distance: '473m',
        latitude: 36.89419516083045,
        longitude: 126.81981523513963,
        address: '운정리 217-4',
        accessurl: 'https://tmap.life/5c1522e3',
        complexity: '여유',
      },
    ],
  },
  {
    parking: '5구역',
    id: 5,
    lots: [
      {
        name: '18번 주차장',
        distance: '936m',
        latitude: 36.88508383890855,
        longitude: 126.82656440741877,
        address: '운정리 801-2',
        accessurl: 'https://tmap.life/5c1522e3',
        complexity: '여유',
      },
      {
        name: '19번 주차장',
        distance: '1400m',
        latitude: 36.88017431597815,
        longitude: 126.8244947772003,
        address: '운정리 812',
        accessurl: 'https://tmap.life/5c1522e3',
        complexity: '여유',
      },
    ],
  },
  {
    parking: '6구역',
    id: 6,
    lots: [
      {
        name: '20번 주차장',
        distance: '974m',
        latitude: 36.88730261258412,
        longitude: 126.83113069661688,
        address: '운정리 902(회전교차로 인근)',
        accessurl: 'https://tmap.life/5c1522e3',
        complexity: '여유',
      },
    ],
  },
];

// 5번 주차장 기준입니다
export const wheatparkingList = [
  {
    parking: '0구역',
    id: 1,
    lots: [
      {
        name: 'P5 주차장',
        distance: '250m',
        latitude: 35.2176351269316,
        longitude: 129.001954127976,
        address: '덕천동 763-28',
        accessurl: 'https://tmap.life/af2f908d',
        complexity: '여유',
      },
      {
        name: 'P4 주차장',
        distance: '700m',
        latitude: 35.2226016433912,
        longitude: 129.004011147358,
        address: '덕천동 600',
        accessurl: 'https://tmap.life/af2f908d',
        complexity: '여유',
      },
      {
        name: 'P3 주차장',
        distance: '1km',
        latitude: 35.2267134864781,
        longitude: 129.004570799032,
        address: '화명동 1718-30',
        accessurl: 'https://tmap.life/af2f908d',
        complexity: '여유',
      },
      {
        name: 'P2 주차장',
        distance: '1.6km',
        latitude: 35.230319494383,
        longitude: 129.005032949033,
        address: '화명동 1718-20',
        accessurl: 'https://tmap.life/af2f908d',
        complexity: '여유',
      },
      {
        name: '대리천 공영주차장',
        distance: '870m',
        latitude: 35.21008079918806,
        longitude: 129.00317626190227,
        address: '덕천동 730-5',
        accessurl: 'https://tmap.life/af2f908d',
        complexity: '여유',
      },
    ],
  },
];

export const complexityList = [
  {
    id: 1,
    complexity: '여유',
    textcolor: '#2BB704',
    buttoncolor: '#31D205',
  },
  {
    id: 2,
    complexity: '보통',
    textcolor: '#E9AB00',
    buttoncolor: '#FB0',
  },
  {
    id: 3,
    complexity: '혼잡',
    textcolor: '#DF0000',
    buttoncolor: '#EF0101',
  },
  {
    id: 4,
    complexity: '만차',
    textcolor: '#505050',
    buttoncolor: '#505050',
  },
  {
    id: 5,
    complexity: '운영마감',
    textcolor: '#CCC',
  },
];

export const parkingFestivalList = [
  {
    festivlaId: 7,
    data: {
      title: '2025 당진 삽교호 드론 라이트 쇼 웹사이트',
      admintitle: '당진삽교호드론라이트쇼',
      subtitle: '페스티맵 제작',
      allbutton: '#fff',
      allbuttonText: '#000',
      background: 'linear-gradient(180deg, #FFF 43%, #F4F3F4 100%)',
      navigatebutton: '#F2F2F5',
      navigatebuttonText: '#111',
    },
  },
  {
    festivlaId: 9,
    data: {
      title: '2025 부산밀페스티벌 웹사이트',
      admintitle: '2025 부산밀페스티벌',
      subtitle: '부산축제조직위원회',
      allbutton: '#FF5C00',
      allbuttonText: '#fff',
      background: 'linear-gradient(180deg, #FFF 43%, #F7F0E4 100%)',
      navigatebutton: '#FFF4EE',
      navigatebuttonText: '#D94E00',
    },
  },
];
